import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { addToCart, getAllCart } from "../redux/features/leadUserCart/leadUserCart";
import { useAppDispatch } from "../redux/app/hooks";
import JMIcon from "../components/Icons/JM-Icon.jpg";
import { toastComponent } from "../components/ToastComponent";
import { ShoppingCart } from "lucide-react";
import { useTheme } from "../hooks/useTheme";

type Props = {
  cartData: any[];
  img: string;
  varient: string;
  link: string;
  design_id: number;
  category_id: number;
  karat: number;
  weight: string;
  onClick?: () => void;
};

const CardComponent = ({ img, varient, link, design_id, category_id, karat, weight, onClick, cartData }: Props) => {
  const [quanity, setquantity] = useState<string>("0");
  const [state, setState] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [mainPageQuantity, setMainPageQuantity] = useState<string>("0");
  const { branding } = useTheme();

  useEffect(() => {
    if (cartData && cartData.length > 0 && cartData[0]?.quantity !== undefined && cartData[0]?.quantity !== null) {
      setquantity(String(cartData[0]?.quantity));
      lastCommittedQuantityRef.current = Number(cartData[0]?.quantity || 0);
      if (Number(cartData[0]?.quantity) > 0) {
        setState(false);
      }
    } else {
      setquantity("0");
      lastCommittedQuantityRef.current = 1;
      setState(true);
    }
  }, [cartData]);

  const RemoveFromtheCart = async (e?: React.MouseEvent) => {
    e?.stopPropagation();
    if (isLoading) return;

    if (Number(quanity) > 0) {
      setIsLoading(true);
      try {
        const newQuantity = Number(quanity) - 1;
        setquantity(String(newQuantity));
        const res = await dispatch(
          addToCart({
            add_cart: [
              {
                design_id: design_id,
                category_id: category_id,
                karat: karat,
                quantity: newQuantity,
              },
            ],
          })
        );

        if (res.payload.success) {
          await dispatch(getAllCart());
          if (Number(quanity) - 1 <= 0) {
            setState(true);
          }
        }
      } catch (error) {
        toastComponent("Failed to remove item from cart", "error");
        setquantity((prev) => String(Number(prev) + 1));
      } finally {
        setIsLoading(false);
      }
    } else {
      setState(true);
    }
  };

  const AddToCart = async (e?: React.MouseEvent) => {
    e?.stopPropagation();
    if (isLoading) return;

    setIsLoading(true);
    try {
      setState(false);
      const newQuantity = Number(mainPageQuantity) + 1;
      setMainPageQuantity(String(newQuantity));
      setquantity(String(newQuantity));
      const res = await dispatch(
        addToCart({
          add_cart: [
            {
              design_id: design_id,
              category_id: category_id,
              karat: karat,
              quantity: newQuantity,
            },
          ],
        })
      );

      if (res.payload.success) {
        await dispatch(getAllCart());
        toastComponent("Added to cart", "success");
      }
    } catch (error) {
      toastComponent("Failed to add item to cart", "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleIncreaseQuantity = async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (isLoading) return;
    const newQuantity = Number(quanity) + 1;
    setquantity(String(newQuantity));
    setIsLoading(true);
    try {
      const res = await dispatch(
        addToCart({
          add_cart: [
            {
              design_id: design_id,
              category_id: category_id,
              karat: karat,
              quantity: newQuantity,
            },
          ],
        })
      );
      if (res.payload.success) {
        await dispatch(getAllCart());
        lastCommittedQuantityRef.current = newQuantity;
      }
    } catch (error) {
      toastComponent("Failed to update quantity", "error");
      setquantity(String(newQuantity - 1));
    } finally {
      setIsLoading(false);
    }
  };

  const fallbackImageSrc = branding?.logo_url || JMIcon;
  const [imageSrc, setImageSrc] = React.useState(img || fallbackImageSrc);
  const lastCommittedQuantityRef = useRef<number>(Number(quanity));

  const inCart = !state && Number(quanity) > 0;

  useEffect(() => {
    setImageSrc(img || fallbackImageSrc);
  }, [img, fallbackImageSrc]);

  return (
    <div className="flex flex-col mt-5">
      {/* Main Card - Rounded with product image (DesignCard-style UI) */}
      <div
        onClick={() => navigate(link, { state: { quantityFromListing: quanity } })}
        className="bg-[#F8F8F8] rounded-xl overflow-hidden group relative cursor-pointer shadow-sm"
      >
        <div className="relative w-full pt-[110%] bg-[#F8F8F8]">
          {/* Full-size image container so image fills entire card area */}
          <div className="absolute inset-0 w-full h-full">
            <img
              className="w-full h-full object-contain min-w-full min-h-full"
              onError={(e) => {
                e.currentTarget.onerror = null;
                setImageSrc(fallbackImageSrc);
                e.currentTarget.className = "w-full h-full object-contain p-4 min-w-full min-h-full";
              }}
              src={imageSrc}
              alt={varient}
            />
          </div>

          {/* Logo top-left */}
          {/* <div className="absolute top-3 left-3 z-10">
            <img
              src={JewelMakerLogo}
              alt="JewelMaker"
              className="h-8 w-20 md:h-9 md:w-24 drop-shadow-sm"
            />
          </div> */}

          {/* Product Metadata Overlay - Bottom Right */}
          {/* <div className="absolute bottom-3 right-3 z-10 text-right">
            <div className="flex flex-col items-center">
              <p
                className="text-[9px] md:text-xs text-gray-800 font-medium mb-0.5"
              >
                {varient}
              </p>
              <p
                className="text-[8px] md:text-[10px] text-gray-600"
              >
                Gross Wt : {weight}
              </p>
              <p
                className="text-[8px] md:text-[10px] text-gray-600"
              >
                Net Wt : {weight}
              </p>
            </div>
          </div> */}
        </div>
      </div>

      {/* Bottom Section - Product Details & CTA (DesignCard-style row layout) */}
      <div className="mt-3 flex items-center justify-between gap-3">
        <div className="flex-1">
          <p
            className="text-sm md:text-base text-gray-800 font-medium mb-1"
          >
            {varient}
          </p>
          <p
            className="text-sm md:text-base text-gray-600"
          >
            Gross Wt : {weight}
          </p>
          <p
            className="text-sm md:text-base text-gray-600"
          >
            Net Wt : {weight}
          </p>
        </div>

        {/* Add to Cart Button or Quantity Selector */}
        {inCart ? (
          <div className="flex items-center bg-gray-200 rounded-full overflow-hidden border border-secondary shadow-sm">
            <button
              type="button"
              onClick={RemoveFromtheCart}
              disabled={isLoading || Number(quanity) === 0}
              className="w-8 h-8 md:w-9 md:h-9 text-secondary-contrast rounded-full flex items-center justify-center hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed background-secondary shadow-sm"
              aria-label="Decrease quantity"
            >
              {isLoading ? (
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
              ) : (
                <span className="text-base font-semibold">−</span>
              )}
            </button>
            <div className="w-10 md:w-12 text-center text-sm md:text-base font-medium">
              {quanity}
            </div>
            <button
              type="button"
              onClick={handleIncreaseQuantity}
              disabled={isLoading}
              className="w-8 h-8 md:w-9 md:h-9 text-secondary-contrast rounded-full flex items-center justify-center hover:opacity-90 transition-opacity disabled:opacity-50 background-secondary shadow-sm"
              aria-label="Increase quantity"
            >
              {isLoading ? (
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
              ) : (
                <span className="text-base font-semibold">+</span>
              )}
            </button>
          </div>
        ) : (
          <button
            type="button"
            onClick={AddToCart}
            disabled={isLoading}
            className="px-1 py-1 md:px-2 md:py-1.5 text-secondary-contrast text-xs md:text-sm rounded-lg transition-colors whitespace-nowrap flex items-center gap-2 disabled:opacity-70 background-secondary shadow-sm"
          >
            {isLoading ? "Adding..." : "Add To Cart"}
            <ShoppingCart className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
};

export default CardComponent;
